import React from 'react'
import "./index.css"

const QuantityControls = ({ cartQuantity, showQuantityButtons, handleDecrease, handleIncrease, disableDecrease, disableIncrease }) => {
    return (
        <div className="quantity-controls">
            {
                showQuantityButtons &&
                <button onClick={handleDecrease} type='button' className="decrease-btn" disabled={disableDecrease}>
                    -
                </button>
            }

            <input
                type="text"
                value={cartQuantity}
                readOnly
                className="quantity-input"
            />
            {
                showQuantityButtons &&
                <button onClick={handleIncrease} type='button' className="increase-btn" disabled={disableIncrease}>
                    +
                </button>

            }
        </div>
    )
}

export default QuantityControls